(function () {
  'use strict';

  var cfgEl = document.getElementById('cst-tiers-config');
  var HIDE_UNTIL_SCROLLED = !!(cfgEl && cfgEl.dataset.hideUntilScrolled === 'true');
  var BAR = '.kaching-bundles__bar';
  var SEL = 'kaching-bundles__bar--selected';

  function text(root, cls) {
    var el = root.querySelector('.kaching-bundles__bar-' + cls);
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function readTier(bar) {
    return {
      bar: bar,
      radio: bar.querySelector('input[type="radio"]'),
      title: text(bar, 'title'),
      badge: text(bar, 'label'),
      sub: text(bar, 'subtitle'),
      price: text(bar, 'price'),
      full: text(bar, 'full-price')
    };
  }

  function build(sticky, container, bars) {
    var tiers = Array.prototype.map.call(bars, readTier).filter(function (t) { return t.radio && t.title; });
    if (tiers.length < 2) return false;

    var btnWrap = container.querySelector('.sticky-atc__button');
    if (!btnWrap) return false;

    var dd = document.createElement('div');
    dd.className = 'cst-dd';

    var chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'cst-chip';
    chip.setAttribute('aria-expanded', 'false');
    chip.innerHTML = '<span><span class="cst-chip__q"></span><span class="cst-chip__p"></span></span>' +
                     '<span class="cst-chip__c" aria-hidden="true">&#9660;</span>';

    tiers.forEach(function (t) {
      var row = document.createElement('button');
      row.type = 'button';
      row.className = 'cst-row';
      var badge = t.badge ? '<span class="cst-badge">' + t.badge + '</span>' : '';
      var sub = t.sub ? '<span class="cst-sub">' + t.sub + '</span>' : '';
      var full = t.full ? '<s>' + t.full + '</s>' : '';
      row.innerHTML = '<span class="cst-radio"></span>' +
        '<span class="cst-main"><span class="cst-title">' + t.title + badge + '</span>' + sub + '</span>' +
        '<span class="cst-price"><b>' + t.price + '</b>' + full + '</span>';
      row.addEventListener('click', function () {
        if (!t.radio.checked) {
          t.radio.checked = true;
          t.radio.dispatchEvent(new Event('change', { bubbles: true }));
          t.radio.dispatchEvent(new Event('click', { bubbles: true }));
        }
        close();
        sync();
      });
      t.row = row;
      dd.appendChild(row);
    });

    function open() { dd.classList.add('is-open'); chip.setAttribute('aria-expanded', 'true'); }
    function close() { dd.classList.remove('is-open'); chip.setAttribute('aria-expanded', 'false'); }

    chip.addEventListener('click', function (e) {
      e.stopPropagation();
      dd.classList.contains('is-open') ? close() : open();
    });
    document.addEventListener('click', function (e) {
      if (!sticky.contains(e.target)) close();
    });

    function sync() {
      var active = tiers.filter(function (t) { return t.bar.classList.contains(SEL) || t.radio.checked; })[0] || tiers[0];
      chip.querySelector('.cst-chip__q').textContent = active.title;
      chip.querySelector('.cst-chip__p').textContent = active.price;
      tiers.forEach(function (t) { t.row.classList.toggle('is-sel', t === active); });
    }

    var wrap = document.createElement('div');
    wrap.className = 'cst-wrap';
    container.insertBefore(wrap, btnWrap);
    wrap.appendChild(chip);
    wrap.appendChild(btnWrap);
    wrap.appendChild(dd);

    var mo = new MutationObserver(sync);
    tiers.forEach(function (t) { mo.observe(t.bar, { attributes: true, attributeFilter: ['class'] }); });
    sync();
    return true;
  }

  function setBusy(el, busy) {
    el.disabled = busy;
    el.setAttribute('aria-busy', busy ? 'true' : 'false');
    var sp = el.querySelector('.loading-overlay__spinner');
    if (sp) sp.classList.toggle('hidden', !busy);
  }

  // De sticky knop post hetzelfde formulier, maar de gift-app van Kaching luistert
  // op de hoofdknop zelf. Daarom versturen we niet zelf, maar klikken we de
  // hoofdknop aan: dan is het pad gegarandeerd identiek, cadeaus inbegrepen.
  // Het thema zet zijn laadstatus vervolgens op die hoofdknop, die uit beeld
  // staat. Daarom spiegelen we die status terug naar de sticky knop.
  function delegateToMainButton(sticky) {
    var stickyBtn = sticky.querySelector('.sticky-atc__button button');
    var main = document.querySelector('button.atc-button.product-form__submit');
    if (!stickyBtn || !main || main === stickyBtn) return false;

    var timer = null;
    stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      setBusy(stickyBtn, true);
      clearTimeout(timer);
      timer = setTimeout(function () { setBusy(stickyBtn, false); }, 6000);
      main.click();
    }, true);

    // Het toevoegen verloopt in twee rondes: eerst het product, daarna de gift-app
    // die de gratis items aanhaakt. Zonder vertraging flikkert de knop daartussen
    // aan-uit-aan, dus we wachten kort af voor we de busy-status opheffen.
    var clearTimer = null;
    new MutationObserver(function () {
      clearTimeout(clearTimer);
      if (main.disabled) return;
      clearTimer = setTimeout(function () {
        clearTimeout(timer);
        setBusy(stickyBtn, false);
      }, 350);
    }).observe(main, { attributes: true, attributeFilter: ['disabled'] });

    return true;
  }

  function hideWhileMainVisible(sticky) {
    if (!HIDE_UNTIL_SCROLLED || !('IntersectionObserver' in window)) return;
    var main = document.querySelector('button.atc-button.product-form__submit');
    if (!main) return;
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('cst-hidden', entries[0].isIntersecting);
    }, { threshold: 0 }).observe(main);
  }

  function attempt() {
    var sticky = document.querySelector('sticky-atc');
    if (!sticky || sticky.dataset.cstTiers) return !!(sticky && sticky.dataset.cstTiers);
    var container = sticky.querySelector('.sticky-atc-container');
    var bars = document.querySelectorAll(BAR);
    if (!container || bars.length < 2) return false;
    sticky.dataset.cstTiers = '1';
    if (!build(sticky, container, bars)) { delete sticky.dataset.cstTiers; return false; }
    delegateToMainButton(sticky);
    hideWhileMainVisible(sticky);
    return true;
  }

  function start() {
    if (attempt()) return;
    var tries = 0;
    var iv = setInterval(function () {
      if (attempt() || ++tries > 60) clearInterval(iv);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();